// ============================================================================
// USER BRANCH ACCESS SERVICE
// ============================================================================

import { get, post, put, del } from '../client/axiosClient';
import { userAccessEndpoints } from '../endpoints/userAccess.endpoints';
import { buildEndpointWithQuery } from '../endpoints/base.endpoints';
import type {
  ApiResponse,
  PaginatedResponse,
  ID,
} from '../types';
import { transformPaginatedResponse } from '../types/common.types';
import type {
  UserBuAccess,
  AssignBuAccessRequest,
  UpdateBuAccessRequest,
  MyBranchItem,
  UserLookup,
  UserAccessFilterParams,
} from '../types/userAccess.types';

class UserAccessService {
  async getAll(params?: UserAccessFilterParams): Promise<PaginatedResponse<UserBuAccess>> {
    const endpoint = params
      ? buildEndpointWithQuery(userAccessEndpoints.list(), params)
      : userAccessEndpoints.list();
    const response = await get(endpoint);
    return transformPaginatedResponse<UserBuAccess>(response.data);
  }

  async getMyBranches(): Promise<ApiResponse<MyBranchItem[]>> {
    const response = await get<ApiResponse<MyBranchItem[]>>(userAccessEndpoints.myBranches());
    return response.data;
  }

  async getUsersLookup(): Promise<ApiResponse<UserLookup[]>> {
    const response = await get<ApiResponse<UserLookup[]>>(userAccessEndpoints.usersLookup());
    return response.data;
  }

  async assign(payload: AssignBuAccessRequest): Promise<ApiResponse<UserBuAccess>> {
    const response = await post<ApiResponse<UserBuAccess>>(userAccessEndpoints.assign(), payload);
    return response.data;
  }

  async update(id: ID, payload: UpdateBuAccessRequest): Promise<ApiResponse<UserBuAccess>> {
    const response = await put<ApiResponse<UserBuAccess>>(userAccessEndpoints.update(id), payload);
    return response.data;
  }

  async revoke(id: ID): Promise<ApiResponse<void>> {
    const response = await del<ApiResponse<void>>(userAccessEndpoints.revoke(id));
    return response.data;
  }
}

export const userAccessService = new UserAccessService();
export default userAccessService;
